import React, { FC } from 'react';

import { Box, Center, HStack, Stack } from '@chakra-ui/react';

import { FootprintBox } from 'components/DataDisplay/Utils/FootprintBox';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { PieChart } from 'components/Visualization';

import { hideTooltipLabel } from './utils';

interface BreakdownProps {
  data: Record<string, any>[];
  isLoading: boolean;
  label: string;
  colorMap: Record<string, string>;
}

export const Breakdown: FC<BreakdownProps> = ({
  data,
  isLoading,
  label,
  colorMap,
}) => {
  const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
  const hasData = total > 0;

  return (
    <FootprintBox
      label={label}
      isLoading={isLoading}
      content={
        <HStack
          w="full"
          h="full"
          justify={hasData ? 'space-between' : 'center'}
          pt={1}
          pb={2}
        >
          <Box w={hasData ? '38%' : '70%'} h="full">
            <PieChart
              data={data}
              dataKey="value"
              total={formatNumber(total)}
              centerLabel="records"
              outerRadius="100%"
              innerRadius="88%"
              activeShape={false}
              colorMap={colorMap}
              legend={false}
              styles={{
                tooltip: {
                  labelFormatter: hideTooltipLabel,
                },
              }}
            />
          </Box>
          {hasData && (
            <Stack w="58%" spacing={1} h="full" justify="center" pl="10%">
              {data.map(item => (
                <HStack key={item.name} minW={0}>
                  <Center
                    boxSize={2}
                    flexShrink={0}
                    bg={colorMap[item.name]}
                    borderRadius="full"
                  />
                  <Box
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    {item.name} ({formatNumber(item.value)})
                  </Box>
                </HStack>
              ))}
            </Stack>
          )}
        </HStack>
      }
    />
  );
};
